import React, { forwardRef, SVGProps } from 'react';

export const ActualSize = forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>((props, ref) => (
  <svg ref={ref} width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
    <g clipPath='url(#clip0_2940_17849)'>
      <rect x='0.5' y='0.5' width='15' height='15' rx='1.5' stroke='currentColor' />
    </g>
    <defs>
      <clipPath id='clip0_2940_17849'>
        <rect width='16' height='16' fill='white' />
      </clipPath>
    </defs>
  </svg>
));
